module.exports = __webpack_public_path__ + "media/images/emoticons/shock-4a78289df48c671874d759372406b5e3.gif";